import { render, staticRenderFns } from "./ShowNotification.vue?vue&type=template&id=bfa07d9c&scoped=true"
import script from "./ShowNotification.vue?vue&type=script&lang=js"
export * from "./ShowNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa07d9c",
  null
  
)

export default component.exports